<template>
  <van-empty
    class="custom-image"
    image="/static/img/pro/no-data.png"
    :description="text"
  />
</template>

<script>
  import Vue from 'vue';
  import {Empty} from 'vant';

  Vue.use(Empty);
  export default {
    name: "noData",
    props: [
      'text'
    ]
  }
</script>

<style scoped>

</style>
